export interface ViewModeConditionPreset {
  key: string;
  label: string;
  formula: string;
}

export const CUSTOM_PRESET: ViewModeConditionPreset = Object.freeze({
  key: 'custom',
  label: 'Своя формула',
  formula: '',
});

import presetsData from './view-mode-condition-presets.json';

const presetsJson = presetsData as { presets: ViewModeConditionPreset[] };
export const VIEW_MODE_CONDITION_PRESETS: readonly ViewModeConditionPreset[] = Object.freeze(
  presetsJson.presets.map(p => Object.freeze(p))
);
